import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import type React from 'react';

const useStylesHighlight = makeStyles((theme: Theme) => ({
  highlighted: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

const removeWildcard = (str: string): string => {
  if (str.endsWith('*')) {
    return str.slice(0, str.length - 1);
  }
  return str;
};

interface HighlightedTextProps {
  highlightTexts?: (string | string[] | null)[];
  text?: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ highlightTexts, text }) => {
  const classes = useStylesHighlight();

  let processedHighlightTexts: string[] = [];
  if (highlightTexts) {
    const flattened = highlightTexts.map((ht) => (typeof ht === 'string' && ht.includes(' ') ? ht.split(' ') : ht));
    processedHighlightTexts = flattened.flat() as string[];
  }

  const lowerCaseHighlightTexts = processedHighlightTexts.map((a) =>
    typeof a === 'string' ? removeWildcard(a).toLowerCase() : a,
  );

  const indexes = lowerCaseHighlightTexts
    .filter((a): a is string => a !== '' && a !== undefined && a !== null)
    .map((a) => [text?.toLowerCase().indexOf(a) ?? -1, a.length] as [number, number])
    .filter((a) => a[0] !== -1);

  return (
    <span>
      {text?.split('').map((part, i) => (
        <span
          // biome-ignore lint/suspicious/noArrayIndexKey: characters are split from text, position is the only identifier
          key={i}
          className={
            indexes.map((index) => i >= index[0] && i < index[0] + index[1]).includes(true) ? classes.highlighted : ''
          }
        >
          {part}
        </span>
      ))}{' '}
    </span>
  );
};

export default HighlightedText;
